// extracted by mini-css-extract-plugin
module.exports = {"pixel":"styles_pixel__rFWHr"};